import React from "react"
import styled from "styled-components"

type Props = {
  label: string
  type: string
  placeholder?: string
  hint?: string
  required?: boolean
  errorText?: string
  disabled?: boolean
  value?: string | number
  defaultValue?: string | number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function FormField({
  label,
  type,
  placeholder,
  hint,
  required = false,
  errorText,
  disabled = false,
  value,
  defaultValue,
  onChange,
}: Props) {
  return (
    <StyledFieldWrapperDiv disabled={disabled}>
      <label>
        {label} {required && <span>*</span>}
      </label>
      <StyledFormFieldDiv>
        <input
          value={value}
          defaultValue={defaultValue}
          type={type}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
        />
      </StyledFormFieldDiv>
      {hint && <small>{hint}</small>}
      {errorText && <StyledErrorSpan>{errorText}</StyledErrorSpan>}
    </StyledFieldWrapperDiv>
  )
}

const StyledFieldWrapperDiv = styled("div")<{ disabled: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 3px;
  color: ${({ disabled }) => (disabled ? "rgba(0, 0, 0, 0.38)" : "inherit")};
`

const StyledFormFieldDiv = styled("div")`
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
`

const StyledErrorSpan = styled("span")`
  color: red;
`
